import type { ErrorLike } from '@apollo/client';

import { useRutilusMutation } from '@graphql/client/useRutilusMutation';
import { upsertConsent } from '@graphql/mutations/rutilus/UpsertConsent';

export const useGiveConsent = (): [
  (agreementUid: string, accepted?: boolean) => Promise<unknown>,
  ErrorLike | undefined,
] => {
  const [upsertConsentMutation, { error: mutationError }] = useRutilusMutation(upsertConsent);

  const setConsent = async (agreementUid: string, accepted = true): Promise<unknown> =>
    upsertConsentMutation({
      variables: { input: { attributes: { accepted, agreementUid } } },
    });
  return [setConsent, mutationError];
};
